import React, { useEffect, useState } from "react";
import DashboardHeader from "./DashboardHeader";
import PacketDownload from "./PacketDownload";
import PacketsBlock from "./PacketsBlock";
import StatsBlock from "./StatsBlock";
import FileChartsBlock from "./StatsBlock/FileChartsBlock";
import { pagination, monthNames, barGraphOptions } from "../../utils/constants";
import { capitalizeFirstLetter } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import {
  getAutoSaveData,
  getUploadedPackets,
  getPacketsGraphData,
  getFilesGraphData,
  appendQueueList,
  getFilesProcessed,
  getPacketsPieChartData,
  getManuallyCheckedItem,
  deleteTemp,
} from "../../context/actions/dashboard";
import "./index.scss";
import { tempAction } from "../../context/actions/tempAction"
import AutoSaveDataModal from "./AutoSaveData/AutoSaveDataModal";

const Dashboard = () => {

  const dispatch = useDispatch();
  const [page, setPage] = useState(pagination.page);
  const [paginations] = useState(pagination.limit);
  let payload = { page: page, limit: paginations };
  const autoSaveData = useSelector((state) => state.dashboard.autoSaveData)
  let [totalFiles, setTotalFiles] = useState([]);
  let [totalPackets, setTotalPackets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLabel, setLoadingLabel] = useState("View more Packets");
  let [packetLoading, setPacketLoading] = useState(true);
  let [fileLoading, setFileLoading] = useState(true);
  let [pieChartLoading, setPieChartLoading] = useState(true);
  let records = useSelector((state) => state?.dashboard?.records);
  let [pieChartData, setPieChartData] = useState([]);
  let [totalFilesProcessedToday, setTotalFilesProcessedToday] = useState(0);
  let [filesProcessedLoading, setFilesProcessedLoading] = useState(true);
  let [filesEditedLoading, setFilesEditedLoading] = useState(true);
  let [averageComputeTimeLoading, setAverageComputeTimeLoading] =
    useState(true);
  let [totalFilesProcessedYesterday, setTotalFilesProcessedYesterday] =
    useState(0);
  let [averageComputeTimeToday, setAverageComputeTimeToday] = useState(0);
  let [averageComputeTimeYesterday, setAverageComputeTimeYesterday] =
    useState(0);
  let [packetUploadedInBarChart, setPacketUploadedInBarChart] = useState([]);
  let [documentsUploadedInBarChart, setDocumentsUploadedInBarChart] = useState(
    []
  );
  let [totalFilesEditedToday, setTotalFilesEditedToday] = useState(0);
  let [totalFilesEditedYesterday, setTotalFilesEditedYesterday] = useState(0);
  let [toggle, setToggle] = useState("Range");
  dispatch({ type: "ISLOADING", data: false });
  useEffect(() => {
    _getAutoSaveData();
    _getUploadedPackets();
    _getFilesProcessed();
    _getManuallyCheckedItem();
    _getPacketsGraphData("month");
    _getDocumentsGraphData("month");
    _getPacketsPieChartData("month");

  }, []);

  /**
   * @description method call get packets data in graph
   */
  const _getUploadedPackets = async () => {
    dispatch(
      getUploadedPackets(payload, (res) => {
        /*setResPayload(res)*/
      })
    );
  };
  const _getAutoSaveData = async () => {
    dispatch(getAutoSaveData());
  };
  /**
   * @description method call get file processed today and yesterday
   */
  const _getFilesProcessed = async () => {
    setFilesProcessedLoading(true);
    setAverageComputeTimeLoading(true);
    dispatch(
      getFilesProcessed((res) => {
        setFilesProcessedLoading(false);
        setAverageComputeTimeLoading(false);
        setTotalFilesProcessedToday(
          res?.totalFilesProcessedToday &&
            res?.totalFilesProcessedToday.length !== 0
            ? res?.totalFilesProcessedToday[0].numberOfFiles
            : 0
        );
        setTotalFilesProcessedYesterday(
          res?.totalFilesProcessedYesterday &&
            res?.totalFilesProcessedYesterday.length !== 0
            ? res?.totalFilesProcessedYesterday[0].numberOfFiles
            : 0
        );
        setAverageComputeTimeToday(
          res?.totalFilesProcessedToday &&
            res?.totalFilesProcessedToday.length !== 0
            ? res?.totalFilesProcessedToday[0].averageComputeTime
            : 0
        );
        setAverageComputeTimeYesterday(
          res?.totalFilesProcessedYesterday &&
            res?.totalFilesProcessedYesterday.length !== 0
            ? res?.totalFilesProcessedYesterday[0].averageComputeTime
            : 0
        );
      })
    );
  };

  /**
   * @description method call get packets data in graph on monthly basis
   */
  const _getPacketsGraphData = (val) => {
    let payload = { dateFilter: val };
    let Val = capitalizeFirstLetter(val);

    setPacketLoading(true);
    dispatch(
      getPacketsGraphData(payload, (res) => {
        setPacketLoading(false);
        if (res) {
          // let totalPackets = [];
          if (res?.totalPackets && res?.totalPackets.length) {
            if (res?.totalPackets.length == 1) {

              if (Val == "Year") {
                setPacketUploadedInBarChart([{ _id: res.totalPackets[0]._id, numberOfPackets: res.totalPackets[0].numberOfPackets }])
              }
              else if (Val == "Quarter") {
                setPacketUploadedInBarChart([{ _id: res.totalPackets[0]._id.quarter + " " + "Quarter", numberOfPackets: res.totalPackets[0].numberOfPackets }])
              }
              // setPacketUploadedInBarChart(res.totalPackets);
              else setPacketUploadedInBarChart([{ _id: monthNames[res.totalPackets[0]._id], numberOfPackets: res.totalPackets[0].numberOfPackets }])
            } else {
              totalPackets = res.totalPackets.map((x) => {
                if (Val === "Month") {
                  return [monthNames[x._id], x.numberOfPackets];
                } else if (Val === "Quarter") {
                  return [x._id.quarter, x.numberOfPackets];
                } else {
                  let year = x._id;

                  return [year.toString(), x.numberOfPackets];
                }
              });

              setTotalPackets(totalPackets);

              let totalPackets1 = [[Val, "Packets"], ...totalPackets];
              setPacketUploadedInBarChart(totalPackets1);
            }
          }
        }
      })
    );
  };

  /**
   * @description method call get files data in graph on select box change
   */
  const _getDocumentsGraphData = (val) => {
    let payload = { dateFilter: val };
    let Val = capitalizeFirstLetter(val);

    setFileLoading(true);
    dispatch(
      getFilesGraphData(payload, (res) => {
        setFileLoading(false);
        if (res) {
          // let totalFiles = [];
          if (res?.totalFiles && res?.totalFiles.length) {
            if (res?.totalFiles.length == 1) {

              if (Val == "Year") {
                setDocumentsUploadedInBarChart([{ _id: res.totalFiles[0]._id, numberOfFiles: res.totalFiles[0].numberOfFiles }])
              }
              else if (Val == "Quarter") {
                setDocumentsUploadedInBarChart([{ _id: res.totalFiles[0]._id.quarter + " " + "Quarter", numberOfFiles: res.totalFiles[0].numberOfFiles }])
              }

              else setDocumentsUploadedInBarChart([{ _id: monthNames[res.totalFiles[0]._id], numberOfFiles: res.totalFiles[0].numberOfFiles }])

            } else {
              totalFiles = res.totalFiles.map((x) => {
                if (Val === "Month") {


                  return [monthNames[x._id], x.numberOfFiles];
                } else if (Val === "Quarter") {


                  return [x._id.quarter, x.numberOfFiles];
                } else {

                  let year = x._id;
                  return [year.toString(), x.numberOfFiles];
                }
              });
              setTotalFiles(totalFiles);
              let totalFiles1 = [[Val, "Documents"], ...totalFiles];
              setDocumentsUploadedInBarChart(totalFiles1);
            }
          }
        }
      })
    );
  };

  /**
   * @description method call get packet data in pie chart on select box change
   */
  const _getPacketsPieChartData = (val) => {
    let payload = { dateFilter: val };
    setPieChartLoading(true);
    dispatch(
      getPacketsPieChartData(payload, (res) => {
        setPieChartLoading(false);
        if (res && res.length) {
          let result = [];
          result.push(["Completed", res[0].numberOfProcessPackets]);
          result.push([
            "Backlog",
            res[0].numberOfPackets - res[0].numberOfProcessPackets,
          ]);
          result = [["Task", "Remaining"], ...result];
          setPieChartData(result);
        } else {
          setPieChartData([]);
        }
      })
    );
  };

  /**
   * @description method call get menually checked item  today and yesterday
   */
  const _getManuallyCheckedItem = async () => {
    setFilesEditedLoading(true);
    dispatch(
      getManuallyCheckedItem((res) => {
        setFilesEditedLoading(false);
        setTotalFilesEditedToday(
          res?.totalFilesEditedToday && res?.totalFilesEditedToday.length !== 0
            ? res?.totalFilesEditedToday[0].numberOfFiles
            : 0
        );
        setTotalFilesEditedYesterday(
          res?.totalFilesEditedYesterday &&
            res?.totalFilesEditedYesterday.length !== 0
            ? res?.totalFilesEditedYesterday[0].numberOfFiles
            : 0
        );
      })
    );
  };

  /**
   * @description method call to loadmore queues data
   * @param {*} activePage
   * @returns
   */

  const _handlePageChange = (activePage) => {
    setPage(activePage);
    setLoading(true);
    setLoadingLabel("loading");
    dispatch(
      appendQueueList({ limit: paginations, page: activePage }, (result) => {
        setLoading(false);
        setLoadingLabel("View More");
      })
    );
  };

  /**
   * @description method call to toggle range/period
   * @param {*} toggle
   * @returns
   */

  const handleTogle = (val) => {
    setToggle(val);
  };
  const [toggletabindex, settoggletabindex] = useState(0);
  const [isAddModelOpen, setIsModelOpen] = useState(false);

  useEffect(() => {
    if (autoSaveData.length === 0) {
      setIsModelOpen(false)
    }

    else setIsModelOpen(true)
  }, [autoSaveData])
  return (
    <>
      {/* {console.log('autoSaveData',autoSaveData)} */}
      <div className="dashboard-wrapper">
        <AutoSaveDataModal showModel={isAddModelOpen} setShowModel={setIsModelOpen}
          autoSaveData={autoSaveData} />
        <DashboardHeader
          totalFilesProcessedToday={totalFilesProcessedToday}
          totalFilesProcessedYesterday={totalFilesProcessedYesterday}
          totalFilesEditedToday={totalFilesEditedToday}
          totalFilesEditedYesterday={totalFilesEditedYesterday}
          averageComputeTimeToday={averageComputeTimeToday}
          averageComputeTimeYesterday={averageComputeTimeYesterday}
        />
        <div className="row-section">
          <StatsBlock
            toggletabindex={toggletabindex}
            settoggletabindex={settoggletabindex}
            totalFilesProcessedToday={totalFilesProcessedToday}
            filesProcessedLoading={filesProcessedLoading}
            totalFilesProcessedYesterday={totalFilesProcessedYesterday}
            totalFilesEditedToday={totalFilesEditedToday}
            filesEditedLoading={filesEditedLoading}
            totalFilesEditedYesterday={totalFilesEditedYesterday}
            averageComputeTimeToday={averageComputeTimeToday}
            averageComputeTimeLoading={averageComputeTimeLoading}
            averageComputeTimeYesterday={averageComputeTimeYesterday}
          />
          <div className="tabs-wrapper">
            {/* <LoaderUI message FullWindow={false} /> */}
            <div className="row-section">
              <FileChartsBlock
                totalPackets={packetUploadedInBarChart}
                totalFiles={documentsUploadedInBarChart}
                handlePacketClick={_getPacketsGraphData}
                handleFileClick={_getDocumentsGraphData}
                packetLoading={packetLoading}
                fileLoading={fileLoading}
                pieChartData={pieChartData}
                handlePieChartClickOption={_getPacketsPieChartData}
                pieChartLoading={pieChartLoading}
                
              />
            </div>
            <div className="row-section">
              <PacketsBlock
                records={records}
                paginations={paginations}
                page={page}
                _handlePageChange={_handlePageChange}
                loading={loading}
                label={loadingLabel}
                _handleTogle={handleTogle}
                toggle={toggle}
                options={barGraphOptions}
              />
            </div>
          </div>
          <div className="row-section">{/* <PacketDownload /> */}</div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
